<template>
	<div id="main">  
			<!-- <img class="top_logo" src="@/assets/logo.png" alt="" /> -->
			<div class="top_tit">针云仓</div>
			<div class="foot_infor">
				<span>泸ICP备 00000001-1不良信息举报邮箱:inhazf-om 违法信息举报电话:021-12345678</span>
				<span>公司主体:海缝觅物联科技有限公司@版权所有</span>
			</div>		
			<div class="login_div">
				<div class="bdy">
					<div class="t_tit2">
						欢迎登录
					</div><!--/t_tit2-->
					<div class="single_tip">账号</div>
					<div class="single">
						<input v-model="loginForm.account" type="text" placeholder="请输入手机号">
					</div><!--/single-->
					<div class="single_tip">密码</div>
					<div class="single">
						<input v-model="loginForm.password" type="password" placeholder="请输入密码">
					</div><!--/single-->
					<div @click="user_login" class="btns">
						登录
					</div><!--/btns-->	
				</div><!--/bdy-->	  		  
			</div>
			<div class="r_earth">
			</div><!--/r_earth-->
	</div>
</template>

<script>
	import { login} from "@/api/index";
	import { Message } from "element-ui";
	import router from '@/router';
	export default {
		data() {
			return {
				loginForm:{
					account:"",
					password:"",
				},
				siteTitle:'',
			}
		},
		computed: {
			zoomAuto: function() {
				return document.documentElement.clientWidth / 1920; //自定义高度需求
			},
			Hframe: function() {
				console.log(window.screen.height);
				return  window.screen.height / (document.documentElement.clientWidth / 1920) + "px"; //自定义高度需求
			}
		},
		components: {
		},
		mounted() {
			//this.getConfig();
		},
		methods: {
			user_login(){				
				if(!this.loginForm.account){
					Message.warning("请输入账号！");
					return;
				}
				if(!this.loginForm.password){
					Message.warning("请输入密码！");
					return;
				}	
				// if(sessionStorage.getItem("token")){
				// 	Message.success("登录成功！");
				// 	router.push({name:'home'});
				// 	setTimeout(() => {
				// 		window.location.reload();
				// 	}, 500);   					
				// 	//window.location.reload();
				// 	return;
				// }				
				let params = {
					username: this.loginForm.account,
					password: this.loginForm.password,
					keep:true,
				};
				login(params).then((res) => {
					if(res.code!=1){
						Message.warning(res.msg);
						return;
					}
					console.log("sss==="+JSON.stringify(res));
					sessionStorage.setItem("token", res.data.userInfo.token);
					Message.success("登录成功！");
					localStorage.setItem("HomeState","0");
					localStorage.setItem("userInfor",JSON.stringify(res.data.userInfo));
					localStorage.setItem("token",res.data.userInfo.token);			
					//console.log("login_res",res);			
					//router.push({path:'/'});
					router.push({name:'home'});
					setTimeout(() => {
						window.location.reload();
					}, 500);  
				});				
			},
		},
		beforeDestroy() {

		},

	}
</script>

<style scoped>
#main{width:1920px;height:100%;min-height: 100vh;position:relative;background:url(../../assets/login_bg.jpg) top center no-repeat;background-size:100%;}
#main .top_logo{top:16%;left:4.2%;display:block;position: absolute;z-index:2;height:100px;display:block;}
#main .top_tit{top:30%;left:4.2%;letter-spacing:3px;display:block;position: absolute;z-index:2;color:#fff;font-size:64px;font-weight:550;display:block;}
#main .foot_infor{position: absolute;z-index:2;bottom:4%;left:4.2%;color:#b8b8b8;}
#main .foot_infor span{display:block;margin-top:10px;font-size:16px;}
.login_div{
	float:right;
	width:420px;
	height:462px;
	margin:7% 5% 0 0;
	background-size:100%;
	background:rgba(255,255,255,0.9);
	border-radius:15px;
	
}
.login_div .bdy{width:82%;margin:0px auto;overflow:hidden;}
.login_div .bdy .t_tit{overflow:hidden;font-size:30px;color:#0edde7;text-align:center;letter-spacing: 5px;margin-top:50px;}
.login_div .bdy .t_tit2{overflow:hidden;font-size:28px;color:#333;text-align:left;letter-spacing: 2px;margin-top:20px;margin-bottom:20px;}
.login_div .bdy .single{overflow:hidden;width:100%;margin:0 auto;height:45px;margin-bottom:25px;background:#fff;border:solid 1px #eee;border-radius:5px;}
.login_div .bdy .single_tip{overflow:hidden;width:100%;margin:0 auto;height:30px;line-height:30px;font-size:16px;margin-bottom:10px;color:#333;}
.login_div .bdy .single img{display:block;height:20px;margin:15px 0 0 5%;float:left;}
.login_div .bdy .single input{float:left;margin:0 0 0 0%;height:45px;background:none;width:95%;border:none;padding:0;padding-left:5%;outline:none;color:#333;font-size:16px;}
.login_div .bdy .single input::-webkit-input-placeholder {color: #fff;}
.login_div .bdy .btns{width:100%;height:50px;line-height:50px;color:#fff;font-size:16px;text-align:center;margin:40px auto;overflow:hidden;background:#2452f6;border-radius:5px;cursor:pointer;}
.r_earth{float:right;width:900px;margin:40px 140px 0 0;}
.big_title{font-family:ziticqtezhanti;font-size:42px;color:#fafefd;line-height:50px;letter-spacing:1px;background: linear-gradient(0deg, #BDE0FF 0%, #FEFFFF 99.5849609375%);
-webkit-background-clip: text;-webkit-text-fill-color: transparent;text-align:center;}
.tab_ts{overflow:hidden;text-align:center;margin-bottom:30px;}
.tab_ts a{cursor:pointer;color:#8d9aa1;text-align:center;line-height:42px;font-size:16px;margin-right:5px;width:142px;height:62px;display: inline-block;}
.tab_ts a:hover,.tab_ts a.cur{color:#fff;}
</style>
